import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Evaluation, EvaluationService } from './GI.Web.Services.g';
import { EvaluationModel } from '../models/evaluation-model';

@Injectable()
export class EvaluationSystemService {
    constructor(private _evaluationService: EvaluationService) { }

    public getAllEvaluations(): Observable<EvaluationModel[]> {
        return this._evaluationService.getAll()
            .map(responses => responses.map(this.toEvaluationModel));
    }

    public getEvaluation(name: string): Observable<EvaluationModel> {
        return this._evaluationService.get(name)
            .map(response => this.toEvaluationModel(response));
    }

    public getUserEvaluation(): Observable<EvaluationModel> {
        return this._evaluationService.getUserEvaluation()
            .map(response => this.toEvaluationModel(response));
    }

    public createEvaluation(evaluation: EvaluationModel): Observable<EvaluationModel> {
        return this._evaluationService.post(evaluation)
            .map(response => this.toEvaluationModel(response));
    }

    private toEvaluationModel(response: Evaluation): EvaluationModel {
        return new EvaluationModel(response);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/evaluation-system.service.ts